/**
 *
 * @param amount in dollars
 * @returns USD
 */
export function dollarToUSD(amount) {
  if (!Number.isFinite(amount)) return '';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
}

/**
 *
 * @param amount in cents
 * @returns USD
 */
export function centsToUSD(amount) {
  if (!Number.isFinite(amount)) return '';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(centsToDollar(amount));
}

/**
 *
 * @param subTotal in dollars
 * @param discountAmount in percentage
 * @returns dollar
 */
export function calculateDiscountPrice(subTotal, discountAmount) {
  return (subTotal * discountAmount) / 100;
}

/**
 *
 * @param number in cents
 * @returns dollars
 */
export function centsToDollar(number) {
  return number / 100;
}

/**
 *
 * @param subTotal in dollars
 * @param discountAmount in dollars | in percentage (number with 2 decimal places)
 * @param discountMethod 'amount' | 'percentage'
 * @returns USD
 */
export function getDiscountPrice(subTotal, discountAmount, discountMethod) {
  if (discountMethod === 'amount') {
    return dollarToUSD(discountAmount);
  } else {
    return dollarToUSD(calculateDiscountPrice(subTotal, discountAmount));
  }
}
